module.exports = __webpack_public_path__ + "img/forms.0d5c912b.svg";